import type { MouseEventHandler } from 'react'
import React from 'react'
import { Tooltip } from '../TooltipV2'
import {
  StyledShareButton,
  StyledShareButtonWithText
} from './ShareButton.styles'

export interface ShareButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>
  text: string
  icon: JSX.Element
  variant: 'tooltip' | 'text'
}

export function ShareButton(props: ShareButtonProps) {
  if (props.variant === 'tooltip') {
    return (
      <>
        <StyledShareButton
          data-tip
          data-for={props.text}
          onClick={props.onClick}
        >
          {props.icon}
        </StyledShareButton>
        <Tooltip place={'top'} id={props.text}>
          {props.text}
        </Tooltip>
      </>
    )
  }

  return (
    <StyledShareButtonWithText
      //@ts-expect-error
      text={props.text}
      icon={props.icon}
      onClick={props.onClick}
    />
  )
}
